module.exports = __webpack_public_path__ + "img/interface_video_short_link.f7136936.png";